import { render, staticRenderFns } from "./SucursalEmpresaRegistrar.vue?vue&type=template&id=051436d0&scoped=true&"
import script from "./SucursalEmpresaRegistrar.vue?vue&type=script&lang=js&"
export * from "./SucursalEmpresaRegistrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051436d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
